'use client';

import React, { useState } from 'react';
import { rejectAll } from '@/lib/consent';

interface CCPALinkProps {
  className?: string;
}

export default function CCPALink({ className = '' }: CCPALinkProps) {
  const [done, setDone] = useState(false);

  function handleOptOut(e: React.MouseEvent) {
    e.preventDefault();
    rejectAll('CCPA');
    setDone(true);
  }

  if (done) {
    return (
      <span className={`text-xs text-green-600 ${className}`}>
        ✓ Opted out of data sharing
      </span>
    );
  }

  return (
    <button
      onClick={handleOptOut}
      className={`text-xs text-gray-500 hover:text-gray-700 underline underline-offset-2 transition-colors ${className}`}
    >
      Do Not Sell or Share My Personal Information
    </button>
  );
}
